import React from 'react';

import { DescriptionList, DescriptionItem } from '@gogame/components';

const Contacts = ({ data }) => {
  return (
    <DescriptionList disableGutters={true} data={data}>
      <DescriptionItem
        label={'Address line 1'}
        field={'address.streetAddress'}
      />
      <DescriptionItem
        label={'Address line 2'}
        field={'address.streetAddress2'}
      />
      <DescriptionItem label={'City'} field={'address.city'} />
      <DescriptionItem
        label={'State / Province / Region'}
        field={'address.region'}
      />
      <DescriptionItem
        label={'Zip / Postal Code'}
        field={'address.postalCode'}
      />
      <DescriptionItem label={'Country'} field={'address.country'} />
      <DescriptionItem label={'Email'} field={'address.email'} />
      <DescriptionItem label={'Phone'} field={'address.phone'} />
    </DescriptionList>
  );
};

export default Contacts;
